import React, { useCallback, useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import {
  Box,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  TableSortLabel,
  Typography,
  Paper,
  IconButton,
  TextField,
  MenuItem,
  Backdrop,
  Button,
  CircularProgress,
  Popover,
  Skeleton,
  ListItemText,
  Autocomplete,
  Tooltip,
  useMediaQuery,
  Stack,
  Fade,
} from '@mui/material';
import { visuallyHidden } from '@mui/utils';
import InputBase from '@mui/material/InputBase';
import SearchIcon from '@mui/icons-material/Search';
import { Link, useLocation, useSearchParams } from 'react-router-dom';
import { Add, ArrowCircleRight, Clear, CloudDownload, CloudUpload, Edit, EditOff, MoreVert, Print, Share } from '@mui/icons-material';
import MUILink from '@mui/material/Link';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorIcon from '@mui/icons-material/Error';
import RunningWithErrorsIcon from '@mui/icons-material/RunningWithErrors';
import { useDispatch } from 'react-redux';
import { display } from '../../redux/reducers/sidebar';
import { MoneyFormatv3 } from '../../library/MoneyFormat';
import { API, graphqlOperation } from 'aws-amplify';
import { getTransactionMaster, listPOSParties, listInvoiceMasterCount, listInvoiceMasterv2Custom } from '../../graphql';
import DeleteInvoice from '../../components/modals/DeleteInvoiceMaster';
import { useNavigate } from 'react-router-dom';
import DeletedSelectedInvoice from '../../components/modals/DeletedSelectedInvoice';
import { ThreeDot } from '../../components/DropDown/ThreeDot';
import printJS from 'print-js';
import DropDownForListing from '../../components/DropDown/DropDown';
import { CSVLink } from 'react-csv';
import { cancelInvoiceMaster } from '../../graphql/mutations';
import CancelInvoice from '../../components/modals/CancelInvoice';

import ExportData from '../../components/modals/ExportData';
import { createDebouncedCallback } from '../../hooks/createDebouncedCallback';
import { ClearIcon } from '@mui/x-date-pickers';

import { updateTitle, updateViewTitle } from '../../redux/reducers/titleSlice';
import CustomDate from '../../components/Date/CustomDate';
import { addDaysToDate, formatUnixTimestamp } from '../../library/dayJs';
import { useWarningModal } from '../../components/modals/AddUnits';
import TeaxtareaField from '../../components/formElements/TeaxtareaField';
import { showErrorSnackbar, showSuccessSnackbar, showWarningSnackbar } from '../../components/snackBar/snakbar';
import { billingCurrencyOptions } from '../../utils/Data/StaticData';
import PeriodDropDown from '../../components/DropDown/PeriodDropDown';
import {
  checkandopenpdf,
  defaultRowsPerPage,
  defaultRowsPerPageOptions,
  fetchAndPrintPDF,
  getDefaultSorting,
  handleFreeze,
} from '../../utils/common';
import { ShareModal } from '../../components/modals/Share';
import MoneyRanger from '../../components/formElements/MoneyRanger';
import { useThemes } from '../../components/Theme/theme';
import { TableCell } from '../../components/Table/TableCell';
import { LedgerTransactionModalv2 } from '../LedgerTransaction';
import TableSearchButton from '../PrimeFigma/Components/TableSearchButton';
import RollingSoon from '../../components/Ui/RollingSoon';
import pdfImage from '../../assets/images/attachments/pdf.png';
import { DateRangeRsuite, MoneyTextFieldRange, SimplePeriodDropdown } from '../../components';
import { useSendEmailModal, SendEmailModalWrapper } from '../../features/Email';
import { MarkEmailUnread } from '@mui/icons-material';
import { useFetchOpeningBalanceDateQuery } from '../../redux/apis/openingbalacedate.api';
import dayjs from 'dayjs';

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}
const headers = [
  { label: 'Party Name', key: 'partyName' },
  { label: 'Contact Number', key: 'contact' },
];

// Invoice Table Headcells  //
const invoiceHeadCells = [
  {
    id: 'InvoiceDate',
    numeric: false,
    disablePadding: true,
    label: 'Date',
    width: '100px',
    search: true,
  },
  {
    id: 'InvoiceNumber',
    numeric: false,
    disablePadding: false,
    label: 'Invoice#',
    width: '100px',
    search: true,
  },
  {
    id: 'partyName',
    numeric: false,
    disablePadding: false,
    label: 'Customer Name',
    width: '170px',
    search: true,
  },
  {
    id: 'PhoneNumber',
    numeric: true,
    disablePadding: true,
    label: 'Phone Number',
    width: '100px',
    search: true,
  },
  {
    id: 'InvoiceAmount',
    numeric: true,
    disablePadding: false,
    label: 'Invoice Amount (₹)',
    width: '120px',
    search: true,
  },
  // {
  //   id: "dueDate",
  //   numeric: false,
  //   disablePadding: false,
  //   label: "Due Date",
  //   width: "150px",
  //   search: true,
  // },
  {
    id: 'statusCD',
    numeric: false,
    disablePadding: false,
    label: 'Status',
    width: '100px',
    search: false,
    disableSort: true,
  },
  // {
  //   id: "BalanceDueAmount",
  //   numeric: false,
  //   disablePadding: false,
  //   label: "Balance Due",
  //   width: "100px",
  // },
  // {
  //   id: "actions",
  //   numeric: false,
  //   disablePadding: false,
  //   label: "Actions",
  //   width: "80px",
  // },
  {
    id: 'Action',
    numeric: false,
    // disablePadding: false,
    label: 'Actions',
    width: '100px',
    search: true,
  },
  // {
  //   id: "actions",
  //   numeric: false,
  //   disablePadding: false,
  //   label: "Actions",
  //   width: "80px",
  //   search: false
  // },
];

function EnhancedTableHead(props) {
  const { onSelectAllClick, order, orderBy, numSelected, rowCount, onRequestSort, headCell, onDelete, setEnableSearch,setShowActions,showActions,scroll } = props;
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };
  const { theme } = useThemes();
  const smalldevices = useMediaQuery('(max-width:480px)');

  return (
    <TableHead>
      <TableRow
        sx={{
          '.MuiTableCell-root': {
            backgroundColor: `${theme.palette.background.tablebg} !important`,
            fontSize: '14px',
          },
          backgroundColor: 'background.tablebg',
          '.MuiTableCell-head': {
            backgroundColor: 'background.tablebg',
            padding: '2px 10px',
            borderBottom: '0px',
          },
          height: '35px',
        }}
      >
        {headCell.map((headCell) => (
          <TableCell
            id={headCell.id === 'Action' ? 'action' : ''}
            key={headCell.id}
            align={headCell.numeric ? 'right' : 'left'}
            padding={headCell.disablePadding ? 'none' : 'normal'}
            sortDirection={orderBy === headCell.id ? order : false}
            sx={{
              minWidth: headCell.width,
              position: headCell.id === 'Action' ? 'sticky' : '',
              right: headCell.id === 'Action' ? 0 : '',
              // borderLeft: headCell.id === "Action" ? "1px solid" : "0px",
            }}
          >
            <Box
              sx={{
               display: 'flex',
                justifyContent:headCell.id === "Action" ? "center" : 'space-between',
                alignItems: 'center',
                flexDirection: headCell.numeric ? 'row-reverse' : '',
                // border: headCell.id === "Action" ? "1px solid black" : "",
                borderRadius:headCell.id === "Action" ? "3px" : "",
                width:"100%",
                backgroundColor:headCell.id === "Action"? "white" : 'background.tablebg',
                boxShadow: (headCell.id === "Action") && (scroll) ?  "0px 4px 8px rgba(0, 0, 0, 0.6)" : "",
                "&:active": 
                {
                  transform: scroll ? "scale(0.92)":"scale(1)",
                },
              }}
               onClick={(e) => {
                if(headCell.label === 'Actions'){
                  setShowActions((pre) => !pre)  
                }
              }}
            >
              <TableSortLabel
                active={
                  orderBy === headCell.id
                    ? true
                    : 'dueDate' === headCell.id && orderBy === 'dueDateTimeStamp'
                    ? true
                    : 'InvoiceDate' === headCell.id && orderBy === 'InvoiceDateTimeStamp'
                    ? true
                    : false
                }
                direction={orderBy === 'dueDateTimeStamp' || 'InvoiceDateTimeStamp' ? order : orderBy === headCell.id ? order : 'asc'}
                onClick={headCell.id === 'Action' || headCell.disableSort ? null : createSortHandler(headCell.id)}
                hideSortIcon={headCell.id === 'Action' || headCell.disableSort}
              >
                <Box sx={{ display: 'flex'}}>
                  <Box sx={{ whiteSpace: 'nowrap' }}>{headCell.label}</Box>
                  <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    {orderBy === headCell.id ? (
                      <Box
                        //  component="span"
                        sx={visuallyHidden}
                      >
                        {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                      </Box>
                    ) : null}
                    {headCell.search === true &&
                      ((headCell.id === "Action") && (scroll) ? (

                          <ArrowCircleRight
                            sx={{
                              transition: 'transform 0.3s ease-in-out',
                              marginLeft: '10px',
                              transform : !showActions ?  'rotate(180deg)' : 'rotate(0deg)',
                              color:!showActions ? 'gray' : '#ee5b2b',
                            }}
                            fontSize="small"
                          />

                      ) : // <SearchIcon
                      //   onClick={(e) => {
                      //     e.preventDefault();
                      //     e.stopPropagation();
                      //     setEnableSearch((prev) => !prev);
                      //   }}
                      //   sx={{ marginLeft: "10px" }}
                      //   fontSize="small"
                      // />
                      null)}
                  </Box>
                </Box>
              </TableSortLabel>
            </Box>
          </TableCell>
        ))}
        {numSelected > 0 ? (
          <TableCell>
            <ThreeDot
              onDelete={() => {
                onDelete(true);
              }}
            />
          </TableCell>
        ) : null}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  numSelected: PropTypes.number.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  onSelectAllClick: PropTypes.func.isRequired,
  order: PropTypes.oneOf(['asc', 'desc']).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};

function AllPos() {
  const { theme } = useThemes();

  const dispatch = useDispatch();
  dispatch(display());
  const navigate = useNavigate();
  let location = useLocation();
  const tableRef = useRef(null);
  const tableRef1 = useRef(null);

  // const firstMount = useRef(true);
  const [firstMount, setfirstMount] = useState({ current: true });
  useEffect(() => {
    if (firstMount.current) {
      setfirstMount({ current: false });
    }
  }, []);


  useEffect(() => {
    const controlAndS = (e) => {
      if (e.ctrlKey && e.key.toLowerCase() === 's') {
        e.preventDefault();
        // showErrorSnackbar("Nothing to save");
      }
    };
    window.addEventListener('keydown', controlAndS);
    return () => {
      window.removeEventListener('keydown', controlAndS);
    };
  }, []);

  const { defaultSortingColumn, defaultSortingOrder } = getDefaultSorting('sales');
  const [salesTableState, setSalesTableState] = useState('pos');
  const [order, setOrder] = useState(defaultSortingOrder);
  const [orderBy, setOrderBy] = useState(defaultSortingColumn);
  console.log({ orderBy });
  const [selected, setSelected] = useState([]);
  const [page, setPage] = useState(0);
  const [dense, setDense] = useState(false);
  const [rowsPerPage, setRowsPerPage] = useState(defaultRowsPerPage);
  const [deleteModalStatus, setDeleteModalStatus] = useState(false);
  const [cancelModalStatus, setCancelModalStatus] = useState(false);

  const [invoiceRows, setInvoiceROws] = useState([]);
  const [circularOpen, setCircularOpen] = useState(true);
  const [itemData, setItemData] = useState({});
  // const [filteredList, setFilteredList] = useState([]);
  const [deleteSelectedModal, setDeleteSelectedModal] = useState(false);
  const [partyDetails, setPartyDetails] = useState([]);
  const [posPartyDetails, setPosPartyDetails] = useState([]);
  const [dataCount, setdataCount] = useState(0);
  const [shareOpen, setShareOpen] = useState(false);
  const defaultFilterColumns = {
    date: '',
    InvoiceNumber: '',
    poscustomername: '',
    dueDate: '',
    Status: '',
    BalanceDue: '',
    InvoiceAmount: '',
    AmountFrom: '',
    AmountTo: '',
    DueDateTo: '',
    DueDateFrom: '',
    InvoiceDateTo: '',
    InvoiceDateFrom: '',
    PhoneNumber: '',
  };
  const [filterColumns, setFilterColumns] = useState(defaultFilterColumns);
  const [showActions,setShowActions] = useState(true)

  const handleResetFilterColumns = (status) => (status === false ? setFilterColumns(defaultFilterColumns) : null);

  const [gstStatus, setGstStatus] = useState('');
  const [backdropOpen, setBackdropOpen] = useState(false);

  let [searchParams, setSearchParams] = useSearchParams();
  let active = searchParams.get('active');
  const [companyDetails, setCOmpanyDetails] = useState([]);

  const [exportItem, setExportItem] = useState(null);
  const [exportModalOpen, setExportModalOpen] = useState(false);
 const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();
    const [exportStartDate, setExportStartDate] = useState('');

  // Email sending states
  const [individualEmailSelection, setIndividualEmailSelection] = useState([]);

  const [anchorEl, setAnchorEl] = useState(null);
  // Click handler for the main box to open the popover
  const handleClickBox = (event) => {
    setAnchorEl(anchorEl ? null : event.currentTarget);
  };
  // Click handler to close the popover
  const handleClose = () => {
    setAnchorEl(null);
  };


  // Check if the popover should be open based on anchorEl
  const open = Boolean(anchorEl);

  let { WarningModal, handleOpen: setWarningOpen } = useWarningModal();

  // Email modal hook
  const { openModal, modalProps } = useSendEmailModal(['salesInvoice', 'customer', 'supplier', 'pos']);

     const { data: openingBalanceDate } = useFetchOpeningBalanceDateQuery(
    {
      invoicetypecd: 'Sales',
      invoiceid: 0,
    },
    {
      refetchOnMountOrArgChange: true,
    }
  );

    const obDate = dayjs(openingBalanceDate?.getMinMaxInvoiceDate?.openingbalancedate).unix();
    useEffect(() => {
      if (startDate > obDate) {
        setExportStartDate(startDate);
      } else {
        setExportStartDate(obDate);
      }
    }, [obDate, startDate]);

  // Options to display in the popover, each with a label and onClick handler
  const options = [
    // {
    //   label: 'Import',
    //   icon: <CloudDownload sx={{ color: 'blue' }} />,
    //   onClick: () => {},
    //   link: '/import-data',
    // },
    {
      label: 'Export',
      icon: <CloudUpload sx={{ color: '#ffa500' }} />,
      // onClick: () => {
      //   if (dataCount > 0) {
      //     setExportModalOpen(true);
      //     setExportItem('INVOICE');
      //   } else {
      //     showWarningSnackbar('No data available for export.');
      //   }
      // },
      link: `/exports/pos?startDate=${exportStartDate}&endDate=${endDate}`,
      // rollingOutSoon: true
    },
  ];



  const handleRequestSort = (event, property) => {
    let isAsc = orderBy === property && order === 'asc';
    if (property === 'dueDate') {
      isAsc = order === 'asc' ? true : false;
      setOrderBy('dueDateTimeStamp');
    } else if (property === 'InvoiceDate') {
      setOrderBy('InvoiceDateTimeStamp');
      isAsc = order === 'asc' ? true : false;
    } else {
      setOrderBy(property);
    }
    setOrder(isAsc ? 'desc' : 'asc');
  };

  // Function to explicitly clear email selection
  const clearEmailSelection = () => {
    setIndividualEmailSelection([]);
  };

  const handleSelectAllClick = (event) => {
    const isChecked = event.target.checked;
    if (isChecked && invoiceRows.length) {
      const newSelected = invoiceRows.map((n) => ({
        Email: n?.partyemail,
        partyaccountid: n?.partyaccountid,
        PartyDisplayName: n?.partyname,
        PartyID: n?.partyid,
        partytypecd: n?.partytypecd,
        invoiceid: n?.invoiceid,
        invoicenumber: n?.invoicenumber,
      }));
      setSelected(newSelected);
      return;
    }
    setSelected([]);
  };
    const [scroll,setScroll] = useState(false)
    useEffect(() => {
    if (invoiceRows.length > 0 && !circularOpen) {
      const width = tableRef1.current?.offsetWidth;
      const screenWidth = window.innerWidth;
      if (width < screenWidth) {
       setScroll(false)
      } else {
        setScroll(true);
      }
    }
  }, [invoiceRows, circularOpen]); 


  const handleClick = (event, row) => {
    const selectedIndex = selected.findIndex((item) => item.invoiceid === row.invoiceid);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, {
        Email: row?.partyemail,
        partyaccountid: row?.partyaccountid,
        PartyDisplayName: row?.partyname,
        PartyID: row?.partyid,
        partytypecd: row?.partytypecd,
        invoiceid: row?.invoiceid,
        invoicenumber: row?.invoicenumber,
      });
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(selected.slice(0, selectedIndex), selected.slice(selectedIndex + 1));
    }
    setSelected(newSelected);
  };

  const handleChangePage = (event, newPage) => {
    if (circularOpen) return;
    if (newPage > page) {
      if (invoiceRows.length !== dataCount)
        if (invoiceRows.length <= rowsPerPage * newPage) listInvoices(false, invoiceRows.length, rowsPerPage);
    }
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    if (circularOpen) return;
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const isSelected = (invoiceId) => selected.some((item) => item.invoiceid === invoiceId);
  
  const rowsPerPageRef = useRef(rowsPerPage);
  rowsPerPageRef.current = rowsPerPage;
  
  const filterColumnsRef = useRef(filterColumns);
  filterColumnsRef.current = filterColumns;
  
  const debouncedSearchRef = useRef();

  if (!debouncedSearchRef.current) {
    debouncedSearchRef.current = createDebouncedCallback(
      (obj) => {
        // Always use current values from refs
        const currentFilterColumns = filterColumnsRef.current;
        const currentRowsPerPage = rowsPerPageRef.current;
        
        // Check if there are any non-empty filter values
        const hasFilters = Object.values(currentFilterColumns).some(value => 
          value && value.toString().trim().length > 0
        );
        
        if (hasFilters) {
          listInvoices(true, 0, currentRowsPerPage, currentFilterColumns);
        } else {
          listInvoices(true, 0, currentRowsPerPage);
        }
      },
      500,
      false
    );
  }

  const filterSearch = useCallback((obj) => {
    debouncedSearchRef.current(obj);
  }, []);
  useEffect(() => {
    if (firstMount.current === false) {
      // Use the debounced search which will check current filterColumns
      filterSearch();
    }
    return () => {};
  }, [filterColumns, filterSearch]);


  const handleFilterBySearch = (event, category, value) => {
    setPage(0);
    let query = value ? value : event.target?.value;
    let name = category;
    const obj = { ...filterColumns };
    if (name != 'GrandTotalAmount') {
      for (const key in obj) {
        if (key == name) {
          obj[key] = query;
        } else {
          // obj[key] = "";
        }
      }
    } else {
      obj['AmountFrom'] = query[0];
      obj['AmountTo'] = query[1];
    }
    setFilterColumns(obj);
  };
  // Avoid a layout jump when reaching the last page with empty rows.
  const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - invoiceRows.length) : 0;

  useEffect(() => {
    if (firstMount.current === false) {
      if (rowsPerPage > invoiceRows.length) {
        listInvoices(true, 0, rowsPerPage);
      } else {
      }
    }
    return () => {};
  }, [rowsPerPage]);

  useEffect(() => {
    if (firstMount.current === false) {
      // setFilteredList([]);
      setInvoiceROws([]);
      setPage(0);
      listInvoices(true, 0, rowsPerPage);
    }
    return () => {};
  }, [order, orderBy]);

  const [filterColumnsMaxValues, setfilterColumnsMaxValues] = useState({
    GrandTotalAmount: 0,
  });

  useEffect(() => {
    API.graphql(
      graphqlOperation(listInvoiceMasterv2Custom, {
        rowfrom: 0,
        limitno: 1,
        columnname: 'invoiceamount',
        ordertype: 'DESC',
        searchmode: 1,
        searcharray: JSON.stringify([{ invoicetypecd: 'PosInvoice' }]),
      })
    )
      .then((res) => {
        console.log(res);
        setfilterColumnsMaxValues((prev) => ({ ...prev, GrandTotalAmount: res?.data?.listInvoiceMasterv2?.[0]?.invoiceamount }));
      })
      .catch((err) => {
        console.log(err);
      });

    return () => {};
  }, []);

  const [limit, setlimit] = useState(rowsPerPage);
  const [dataLoader, setDataLoader] = useState(true);
  async function listInvoices(reset, from, to, filterColumn) {
    return new Promise(async (resolve, reject) => {
      try {
        setDataLoader(true);
        if (invoiceRows.length / rowsPerPage == page + 1) {
          setlimit(to);
        } else if (invoiceRows.length / rowsPerPage < 1) {
          setlimit(rowsPerPage - invoiceRows.length);
        }
        setCircularOpen(true);
        if (reset) {
          setInvoiceROws([]);
          setPage(0);
        }
        let searchMode = 1;
        let SearchArray = [{ invoicetypecd: 'PosInvoice' }];
        filterColumn = filterColumn ? filterColumn : filterColumns;
        // Handle AmountFrom and AmountTo together to avoid duplicates
        const amountFrom = filterColumn.AmountFrom ||'';
        const amountTo = filterColumn.AmountTo || ''
        
        if (amountFrom || amountTo) {
          searchMode = 1;
          // Ensure From < To before adding to SearchArray
          const lowerAmount = Number(amountFrom < amountTo ? amountFrom : amountTo);
          const higherAmount = Number(amountFrom < amountTo ? amountTo : amountFrom);
          
          // Add both values with correct order
          SearchArray = [...SearchArray, { amountfrom: lowerAmount }, { amountto: higherAmount }];
        } else if (amountFrom) {
          searchMode = 1;
          SearchArray = [...SearchArray, { amountfrom: amountFrom }];
        } else if (amountTo) {
          searchMode = 1;
          SearchArray = [...SearchArray, { amountto: amountTo }];
        }

        Object.keys(filterColumn).map((key) => {
          if (filterColumn[key]?.toString()?.length > 0) {
            // Skip AmountFrom and AmountTo as they are handled above
            if (key !== 'AmountFrom' && key !== 'AmountTo') {
              searchMode = 1;
              SearchArray = [...SearchArray, { [key?.toLocaleLowerCase()]: filterColumn[key] }];
            }
          }
        });
        const resActive = await API.graphql(
          graphqlOperation(listInvoiceMasterv2Custom, {
            rowfrom: from,
            limitno: to,
            columnname: orderBy,
            ordertype: order,
            searchmode: searchMode,
            searcharray: JSON.stringify(SearchArray),
          })
        );
        const resCount = await API.graphql(
          graphqlOperation(listInvoiceMasterCount, {
            columnname: orderBy,
            ordertype: order,
            searchmode: searchMode,
            searcharray: JSON.stringify(SearchArray),
          })
        );

        setdataCount(resCount.data.listInvoiceMasterCount[0]?.invoicemasterlistcount);
        let arr = [];
        let arrD = [];
        if (resActive.data?.listInvoiceMasterv2 != null) {
          let Id = '';
          let type = '';
          arr = resActive.data?.listInvoiceMasterv2.filter((ele) => {
            ele.partyname = ele.partydisplayname;
            partyDetails.map((item) => {
              if (item.partylegalname == ele.partyname) {
                type = item.partytypeCd;
                Id = item.partyid;
              }
            });
            ele.customerorsupplierid = ele.partyid;
            ele.customerorsuppliertype = type;
            // Calculate due date using utility function
            ele.dueDate = addDaysToDate(ele.invoicedate, ele.creditduration);

            // Format invoice date using utility function
            ele.invoicedate = formatUnixTimestamp(ele.invoicedate);
            ele.invoiceamount *= ele.currencyrate;
            
            // Ensure party email is available for email functionality
            ele.partyemail = ele.partyemail || '';

            ele.statuscd = ele.receivedamount >= ele.invoiceamount ? 'Paid' : ele.receivedamount === 0 ? 'Unpaid' : 'Partial';
            ele.balancedue =
              Number(ele.InvoiceAmount) - Number(ele.ReceivedAmount) > 0 ? Number(ele.InvoiceAmount) - Number(ele.ReceivedAmount) : 0;
            ele.dueDateTimeStamp = new Date(ele.dueDate).getTime();
            ele.InvoiceDateTimeStamp = new Date(ele.InvoiceDate).getTime();
            // Get the Unix timestamp in milliseconds
            return ele;
          });
          // setInvoiceROws(arr)
          // setFilteredList(arr)
        }
        let cArr = [...arr, ...arrD];
        if (reset) {
          setInvoiceROws((prev) => [...cArr]);
          setDataLoader(false);
          // setFilteredList((prev) => [...cArr]);
        } else {
          setInvoiceROws((prev) => [...prev, ...cArr]);
          setDataLoader(false);
          // setFilteredList((prev) => [...prev, ...cArr]);
        }

        setCircularOpen(false);
        setlimit(0);
        resolve();
      } catch (error) {
        setlimit(0);
        resolve();
        console.log(error);
      }
    });
  }

  useEffect(() => {
    setCircularOpen(true);
  }, []);

  useEffect(() => {
    setListSelection('All');
    setInvoiceROws([]);
    // setFilteredList([]);
    setCircularOpen(true);
    listInvoices(true, 0, rowsPerPage);
    setSelected([]);
    clearEmailSelection();
    listPosPartyDetails();
  }, [salesTableState]);

  //New Changes
  // useEffect(() => {
  //     setFilteredList(invoiceRows);
  // }, [invoiceRows]);

  //New Changes
const financialYear = useSelector((state) => state?.userPrefrenceandReducer?.financialYear);

    useEffect(() => {
      if (filterColumns.InvoiceDateFrom && filterColumns.InvoiceDateTo) {
        setStartDate(filterColumns.InvoiceDateFrom);
        setEndDate(filterColumns.InvoiceDateTo);
      } else {
        setStartDate(financialYear?.startdate);
        setEndDate(financialYear?.enddate);
      }
    }, [filterColumns, financialYear]);

  function invoiceFilterSearch(event, category) {
    setPage(0);
    const query = event.target.value;
    const name = category;
    const obj = { ...filterColumns };
    for (const key in obj) {
      if (key == name) {
        obj[key] = query;
      } else {
        // obj[key] = "";
      }
    }
    setFilterColumns(obj);
  }
  const getCompany = useSelector((state) => state?.companyReducer.companyDetails);
   






  const companyLoaded = useSelector((state) => state?.companyReducer.Loaded);
  async function getCompanyDetails() {
    try {
      setGstStatus(getCompany?.relatedcompanydetailsnew[0].registrationtype);
      setCOmpanyDetails(companyDetails.data);
    } catch (error) {
      console.log('error', error);
    }
  }
  useEffect(() => {
    if (getCompany) getCompanyDetails();
  }, [getCompany]);
  //New Changes

  const [ledgerModalStartDate, setLedgerModalStartDate] = useState(0);
  const [ledgerModalEndDate, setLedgerModalEndDate] = useState(0);
  const [modalData, setModalData] = useState([]);
  const [allModalData, setAllModalData] = useState([]);
  const [modalTableLength, setModalTableLength] = useState(0);
  const [accountName, setAccountName] = useState('');
  const [accountID, setAccountID] = useState('');
  const cancel = async (id, reason) => {
    return new Promise(async (resolve, reject) => {
      try {
        let payload = {
          InvoiceID: id,
          CancelFlag: 1,
          CancelRemark: state.reason,
        };
        let response = await API.graphql(
          graphqlOperation(cancelInvoiceMaster, {
            updateInvoicemasterInput: payload,
          })
        );
        showSuccessSnackbar('Credit Note Cancelled');
        // listCreditDebitMaster(false,0);
      } catch (error) {
        showErrorSnackbar('Something Went Wrong !');
        console.log(error);
      } finally {
        resolve();
      }
    });
  };
  const [state, setState] = useState({
    reason: '',
    errorFields: {
      reason: '',
    },
    errorStatus: {
      reason: false,
    },
  });
  const getTransactiondata = (array) => {
    return new Promise((resolve) => {
      let ids = [];
      const items = [];
      array?.map(async (ele) => {
        if (!ids?.includes(ele?.TransactionID)) {
          ids.push(ele?.TransactionID);
          const resTransactionDetails = await API.graphql(
            graphqlOperation(getTransactionMaster, {
              TransactionID: ele?.TransactionID,
            })
          );
          items?.push({
            id: resTransactionDetails.data.getTransactionMaster?.TransactionID,
            typeCD: resTransactionDetails.data.getTransactionMaster?.TransactionTypeCD,
            Vno: resTransactionDetails.data.getTransactionMaster?.VoucherNumber,
          });
        }
      });

      setTimeout(() => {
        resolve(items);
      }, 2000);
    });
  };

  const [InvoiceSettings, setInvoiceSettings] = useState(null);
  const [POSInvoiceSettings, setPOSInvoiceSettings] = useState(null);

  const cancelInvoice = async (data) => {
    try {
      let payload = {
        InvoiceID: data.InvoiceID,
        CancelFlag: data.CancelFlag == 0 ? 1 : 0,
      };
      setCancelModalStatus(true);
      let res = await API.graphql(
        graphqlOperation(cancelInvoiceMaster, {
          updateInvoicemasterInput: payload,
        })
      );
    } catch (error) {
      console.log(error);
    }
  };

  const userPrefrenceandReducer = useSelector((state) => state.userPrefrenceandReducer);
  useEffect(() => {
    if (userPrefrenceandReducer?.financialYear) {
      setLedgerModalStartDate(userPrefrenceandReducer?.financialYear?.StartDate);
      setLedgerModalEndDate(userPrefrenceandReducer?.financialYear?.EndDate);
    }
  }, [userPrefrenceandReducer]);
  //New Changes
  const [bankDetails, setBankDetails] = useState([]);
  const AccountTypes = [
    { option: 'Current Account', value: '1' },
    { option: 'Savings Account', value: '2' },
  ];

  const handleRowClick = (row) => {
    // if (row.ExpiredTimeStamp === 0 &&
    //   row.CancelFlag == 0) {
    // dispatch(
    //   updateViewTitle(
    //     row.CancelFlag == 1
    //       ? { type: "Cancelled", name: row.InvoiceNumber }
    //       : { type: "", name: row.InvoiceNumber }
    //   )
    // );
    dispatch(updateTitle(row.invoicenumber));
    if (row.InvoiceTypeCD == 'SalesInvoice') {
      navigate('/viewnewinvoicetax', {
        state: { id: row.InvoiceID, view: true },
      });
    } else if (row.InvoiceTypeCD == 'NON-TAXABLE') {
      navigate('/viewinvoiceNonTaxable', {
        state: { id: row.InvoiceID, view: true },
      });
    } else if (row.invoicetypecd == 'PosInvoice') {
      navigate('/viewpos', {
        state: { id: row.invoiceid, view: true },
      });
    }
    // }
    // else{
    //   navigate("/viewpos", {
    //     state: { id: row.InvoiceID, StrictView: true },
    //   });
    // }
  };

  const [ListSelection, setListSelection] = useState('All');

  async function listPosPartyDetails() {
    try {
      let posPartyArr = [];
      let filterPosArr = [];
      const res = await API.graphql(graphqlOperation(listPOSParties));

      if (res.data.listPOSParties.length > 0) {
        res.data.listPOSParties.map((ele) => {
          posPartyArr.push({
            partyName: ele.partyname,
            contact: ele.relatedphonecontacts[0]?.phonenumber ? `\u200B${ele.relatedphonecontacts[0]?.phonenumber}` : '',
          });
        });
        posPartyArr.map((ele) => {
          if (ele.partyName || ele.contact) {
            filterPosArr.push(ele);
          }
        });
        setPosPartyDetails(filterPosArr.reverse());
      }
    } catch (error) {
      console.log('error', error);
    }
  }

  const csvLink = {
    filename: 'PosParty.csv',
    headers: headers,
    data: posPartyDetails,
  };
  const [EnableSearch, setEnableSearch] = useState(false);
  const DateRangeRef = useRef(null);
  const openDateRange = () => {
    setEnableSearch(true);
    DateRangeRef?.current?.openDatePicker();
  };

  const device = useMediaQuery(theme.breakpoints.down('sm'));

  const Freeze = useSelector((state) => state.userPrefrenceandReducer?.financialYear?.freezestatus);
  const [rolling, setRolling] = useState(false);

  return (
    <Box className="noTableCellBorder">
      {/* <ConfirmDeleteModal open={deleteModalStatus} setOpen={setDeleteModalStatus} /> */}

      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          borderTopRightRadius: '12px',
          borderTopLeftRadius: '12px',
          padding: '8px 10px',
          backgroundColor: 'primary.main',
          // marginBottom:'20px'
        }}
      >
        <Box sx={{ display: 'flex', flex: { xs: 1, sm: 0 } }}>
          <Link
            onClick={(e) => {
              if (Freeze == 1) {
                e.preventDefault();
                handleFreeze();
              }
              localStorage.removeItem('SalesIDTaxable');
              localStorage.removeItem('SalesTaxViewMode');
              localStorage.removeItem('SalesIDNonTaxable');
              localStorage.removeItem('SalesNonTaxViewMode');
              localStorage.removeItem('PosID');
              localStorage.removeItem('PosViewMode');
            }}
            to={
              // gstStatus == 1
              //   ? "/addinvoiceNonTaxable"
              //   : salesTableState === "pos"
              //     ? "/addpos"
              //     : "/addinvoiceTaxable"
              salesTableState === 'pos' ? '/newpos' : '/addnewinvoicetax'
            }
            // target="_blank"
          >
            <Button
              sx={{
                whiteSpace: 'nowrap',
                border: '1px solid white',
                boxShadow: '0px 6px 8px rgba(0, 0, 0, 0.5)',
                m: '0 10px',
                fontWeight: 'bold',
                backgroundColor: 'white',
                '&:hover': {
                  backgroundColor: 'white', // Override hover background color
                },
              }}
              variant="outlined"
              startIcon={<Add />}
            >
              Add Invoice
            </Button>
          </Link>
        </Box>

        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <TableSearchButton
            setEnableSearch={setEnableSearch}
            EnableSearch={EnableSearch}
            id={'allPosSearch'}
            onClick={handleResetFilterColumns}
          />
          <Box
            sx={{
              display: {
                xs: 'none',
                sm: 'flex',
                md: 'flex',
                lg: 'flex',
                xl: 'flex',
                gap: '10px',
              },
              alignItems: 'center',
            }}
          >
            <Typography sx={{ whiteSpace: 'nowrap', fontSize: '13px', color: 'white' }}>
              Total : {dataCount} Items {selected.length != 0 ? `(Selected Items :${selected.length}/${dataCount})` : ''}
            </Typography>
            <DropDownForListing
              name={'ser'}
              value={ListSelection}
              sx={{ color: 'white' }}
              onChange={(e) => {
                let value = e.target.value;
                setListSelection(e.target.value);
                setFilterColumns((prev) => ({
                  ...prev,
                  CancelFlag: value != 'All' ? (value == 'Active' ? 0 : 1) : '',
                }));
                setPage(0);
              }}
            />
            <div className='dropdown-list'>
            <SimplePeriodDropdown
              value={{
                from: filterColumns.InvoiceDateFrom || null,
                to: filterColumns.InvoiceDateTo || null,
              }}
              onChange={(range) => {
                setFilterColumns((prev) => ({
                  ...prev,
                  InvoiceDateFrom: range.from || '',
                  InvoiceDateTo: range.to || '',
                }));
              }}
              title=""
              selectedWhenNull="year"
            />
            </div>
            {/* <IconButton aria-label="filter">
                    <FilterAlt sx={{color:'#fff'}} />
                  </IconButton>
                  <IconButton aria-label="more">
                      <MoreVert sx={{color:'#fff'}} />
                  </IconButton> */}
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                borderRadius: '5px',
                p: 1,
                cursor: 'pointer',
                '&:hover': {
                  borderColor: '#ccc',
                  backgroundColor: theme.palette.input.border || '#f5f5f5',
                },
              }}
              onClick={handleClickBox} // Toggle the popover on box click
            >
              <MoreVert sx={{ fontSize: '20px', color: '#fff' }} />

              <Popover
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                  vertical: 'bottom',
                  horizontal: 'left',
                }}
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'left',
                }}
              >
                <Box sx={{ p: 1, minWidth: '200px' }}>
                  {
                    options.map((option,index) => 
                      option.rollingOutSoon ? 
                      (
                        <Typography
                          key={index}
                          onClick={() => {
                            handleClose();
                          }}
                          sx={{
                            padding: '8px',
                            display: 'flex',
                            alignItems: 'center',
                            // '&:hover': {
                            //   backgroundColor: theme.palette.input.border || '#f5f5f5',
                            // },
                          }}
                        >
                      <Tooltip 
                        title={<RollingSoon />}
                        placement="right"
                        PopperProps={{
                          sx: {
                            '& .MuiTooltip-tooltip': {
                              backgroundColor: 'transparent',
                              boxShadow: 'none',
                              padding: 0,
                            } 
                          }
                        }}
                      >      
                        <Box
                            sx={{
                              display: 'flex',
                              alignItems: 'center',
                            }}
                          >
                            {option.icon}
                            <span style={{ marginLeft: '8px', opacity: 0.5 }}>
                              {option.label}
                            </span>
                        </Box>
                      </Tooltip> 
                        </Typography>
                      ): 
                      (<Link style={{ textDecoration: 'none', color: 'inherit' }} to={option.link} state={{ fromLink: '/customerList' }}>
                          <Typography
                            key={index}
                            onClick={() => {
                              handleClose();
                              option.onClick();
                            }}
                            sx={{
                              cursor: 'pointer',
                              padding: '8px',
                              display: 'flex',
                              alignItems: 'center',
                              // '&:hover': {
                              //   backgroundColor: theme.palette.input.border || '#f5f5f5',
                              // },
                            }}
                          >
                            {option.icon}
                            <span style={{ marginLeft: '8px' }}>{option.label}</span>
                          </Typography>
                      </Link>)
                    )
                  }
                </Box>
              </Popover>
            </Box>
          </Box>
        </Box>
      </Box>
      <>
        <Box
          sx={{
            // boxShadow: "inset 0 0 8px #d7d7d73b",
            boxShadow: 'rgb(33 35 38 / 10%) 0px 10px 10px -10px',
            borderBottomRightRadius: '12px',
            borderBottomLeftRadius: '12px',
            // backgroundColor: theme.palette.bodyGray.secondary,
            // borderRadius:'12px',
            padding: {
              // xs: "8px 12px",
            },
            '.css-1mxz8qt-MuiPaper-root': {
              boxShadow: 'none',
            },
            '.MuiTableCell-root': {
              padding: '1px 10px',
              fontSize: '13px',
            },
            '.MuiTableCell-head': {
              backgroundColor: 'background.tablebg',
              padding: '5px 10px',
              borderBottom: '0px',
            },
          }}
        >
          {/* All Sales Table */}

          {invoiceRows <= 0 && device ? (
            <Typography
              sx={{
                height: '70vh',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              No data found
            </Typography>
          ) : (
            <>
              {salesTableState === 'pos' && (
                <Box
                  sx={{
                    width: '100%',
                    overflow: 'hidden',
                    boxShadow: 'none',
                  }}
                >
                  <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                    {posPartyDetails?.length > 0 && (
                      <CSVLink
                        style={{
                          color: 'primary.main',
                          align: 'center',
                          marginBottom: '5px',
                          marginRight: '5px',
                        }}
                        {...csvLink}
                      >
                        Download Pos Party Details
                      </CSVLink>
                    )}
                  </Box>
                  <TableContainer
                    ref={tableRef}
                    className="custom-scrollbar"
                    sx={{
                      height: {
                        sm: 'calc( 100vh - 230px )',
                        xs: 'calc( 100vh - 180px )',
                      },
                    }}
                  >
                    <Table
                      stickyHeader
                      aria-label="sticky table"
                      // sx={{ minWidth: 750 }}
                      aria-labelledby="tableTitle"
                      size={dense ? 'small' : 'medium'}
                    >
                      <EnhancedTableHead
                        EnableSearch={EnableSearch}
                        setEnableSearch={setEnableSearch}
                        numSelected={selected.length}
                        order={order}
                        orderBy={orderBy}
                        onSelectAllClick={handleSelectAllClick}
                        onRequestSort={handleRequestSort}
                        rowCount={dataCount}
                        headCell={invoiceHeadCells}
                        onDelete={() => setDeleteSelectedModal(true)}
                        setShowActions = {setShowActions}
                        showActions = {showActions}
                        scroll = {scroll}
                      />
                      <TableBody ref={tableRef1}>
                        <TableRow
                          sx={{
                            '.MuiTableCell-root': {
                              backgroundColor: 'transparent ',
                              padding: '8px 15px',
                            },
                            '.css-wrnu0i-MuiInputBase-root': {
                              fontSize: '13px',
                            },
                            '.css-xk0adg-MuiButtonBase-root-MuiIconButton-root': {
                              padding: '2px 4px',
                            },
                            '.css-1gqfvv-MuiPaper-root': {
                              boxShadow: 'none',
                              borderBottom: 'solid 1px rgba(0,0,0,0.24)',
                              borderRadius: '0px',
                            },
                            // visibility: !EnableSearch ? "collapse" : "visible",
                            display: !EnableSearch ? 'none' : 'content',
                          }}
                        >
                          {/* <TableCell></TableCell> */}
                          <TableCell>
                            <Paper
                              id="allPosSearch"
                              sx={{
                                p: '2px 4px',
                                display: 'flex',
                                alignItems: 'center',
                                width: '100%',
                              }}
                            >
                              {/* <InputBase
                        name="supplierInvoiceDate"
                        value={filterColumns.supplierInvoiceDate}
                        onChange={(e) =>
                          handleFilterBySearch(e, "SupplierInvoiceDate")
                        }
                        sx={{ flex: 1 }}
                        placeholder="Search"
                        autoComplete="off"
                      /> */}
                              <DateRangeRsuite
                                containerRef={tableRef}
                                ref={DateRangeRef}
                                value={[
                                  filterColumns.InvoiceDateFrom ? (filterColumns.InvoiceDateFrom) : null,
                                  filterColumns.InvoiceDateTo ? (filterColumns.InvoiceDateTo) : null,
                                ]}
                                onChange={(e) => {
                                  setFilterColumns((prev) => ({
                                    ...prev,
                                    InvoiceDateFrom: e.from ? e.from : '',
                                    InvoiceDateTo: e.to ? e.to : '',
                                  }));
                                }}
                                className="hide-input-outline hide-input-border"
                              />
                              {/* <IconButton type="button" sx={{ p: '0px' }}>
                                {filterColumns.InvoiceDateFrom !== '' || filterColumns.InvoiceDateTo != '' ? (
                                  <Clear
                                    fontSize="small"
                                    onClick={() => {
                                      setFilterColumns((prev) => ({
                                        ...prev,
                                        InvoiceDateFrom: '',
                                        InvoiceDateTo: '',
                                      }));
                                      // setFilteredList(rows);
                                    }}
                                  />
                                ) : (
                                  <SearchIcon fontSize="small" />
                                )}
                              </IconButton> */}
                            </Paper>
                          </TableCell>
                          <TableCell>
                            <Paper
                              sx={{
                                p: '2px 4px',
                                display: 'flex',
                                alignItems: 'center',
                                width: '100%',
                              }}
                            >
                              <InputBase
                                name="InvoiceNumber"
                                value={filterColumns.InvoiceNumber}
                                onChange={(e) => invoiceFilterSearch(e, 'InvoiceNumber')}
                                sx={{ flex: 1 }}
                                placeholder="Search"
                                autoComplete="off"
                              />
                              <IconButton type="button" sx={{ p: '0px' }}>
                                {filterColumns.InvoiceNumber !== '' ? (
                                  <Clear
                                    fontSize="small"
                                    onClick={() => {
                                      setFilterColumns((prev) => ({
                                        ...prev,
                                        InvoiceNumber: '',
                                      }));
                                      // setFilteredList(invoiceRows);
                                    }}
                                  />
                                ) : (
                                  <SearchIcon fontSize="small" />
                                )}
                              </IconButton>
                            </Paper>
                          </TableCell>
                          <TableCell>
                            <Paper
                              sx={{
                                p: '2px 4px',
                                display: 'flex',
                                alignItems: 'center',
                                width: '100%',
                              }}
                            >
                              <InputBase
                                name="poscustomername"
                                value={filterColumns.poscustomername}
                                onChange={(e) => invoiceFilterSearch(e, 'poscustomername')}
                                sx={{ flex: 1 }}
                                placeholder="Search"
                                autoComplete="off"
                              />
                              <IconButton type="button" sx={{ p: '0px' }}>
                                {filterColumns.poscustomername !== '' ? (
                                  <Clear
                                    fontSize="small"
                                    onClick={() => {
                                      setFilterColumns((prev) => ({
                                        ...prev,
                                        poscustomername: '',
                                      }));
                                      // setFilteredList(invoiceRows);
                                    }}
                                  />
                                ) : (
                                  <SearchIcon fontSize="small" />
                                )}
                              </IconButton>
                            </Paper>
                          </TableCell>
                          <TableCell>
                            <Paper
                              sx={{
                                p: '2px 4px',
                                display: 'flex',
                                alignItems: 'center',
                                width: '100%',
                              }}
                            >
                              <InputBase
                                name="PhoneNumber"
                                value={filterColumns.PhoneNumber}
                                onChange={(e) => invoiceFilterSearch(e, 'PhoneNumber')}
                                sx={{ flex: 1 }}
                                placeholder="Search"
                                autoComplete="off"
                              />
                              <IconButton type="button" sx={{ p: '0px' }}>
                                {filterColumns.PhoneNumber !== '' ? (
                                  <Clear
                                    fontSize="small"
                                    onClick={() => {
                                      setFilterColumns((prev) => ({
                                        ...prev,
                                        PhoneNumber: '',
                                      }));
                                      // setFilteredList(invoiceRows);
                                    }}
                                  />
                                ) : (
                                  <SearchIcon fontSize="small" />
                                )}
                              </IconButton>
                            </Paper>
                          </TableCell>
                          <TableCell>
                            <Paper
                              sx={{
                                p: '2px 4px',
                                display: 'flex',
                                alignItems: 'center',
                                width: '100%',
                              }}
                            >
                              <Stack direction={'row'} height={'32px'} gap="5px">
                                <MoneyTextFieldRange
                                  value={[filterColumns.AmountFrom,filterColumns.AmountTo]}
                                  onChange={(e) => {
                                    handleFilterBySearch(e, 'GrandTotalAmount', e);
                                  }}
                                />
                                <IconButton type="button" sx={{ p: '0px' }}>
                                  {filterColumns.AmountFrom !== '' || filterColumns.AmountTo !== '' ? (
                                    <Clear
                                      fontSize="small"
                                      onClick={() => {
                                        setFilterColumns((prev) => ({
                                          ...prev,
                                          AmountFrom: '',
                                          AmountTo: '',
                                        }));
                                      }}
                                    />
                                  ) : (
                                    <SearchIcon fontSize="small" />
                                  )}
                                </IconButton>
                              </Stack>
                            </Paper>
                          </TableCell>

                          {/* <TableCell>
                            <Paper
                              sx={{
                                p: "2px 4px",
                                display: "flex",
                                alignItems: "center",
                                width: "100%",
                              }}
                            >
                              <CustomDate
                                value={[
                                  filterColumns.DueDateFrom
                                    ? dayjs.unix(filterColumns.DueDateFrom)
                                    : null,
                                  filterColumns.DueDateTo
                                    ? dayjs.unix(filterColumns.DueDateTo)
                                    : null,
                                ]}
                                onChange={(e) => {
                                  setFilterColumns((prev) => ({
                                    ...prev,
                                    DueDateFrom: e.from ? e.from : "",
                                    DueDateTo: e.to ? e.to : "",
                                  }));
                                }}
                              />
                              <IconButton type="button" sx={{ p: "0px" }}>
                                {filterColumns.DueDateFrom !== "" ||
                                filterColumns.DueDateTo != "" ? (
                                  <Clear
                                    fontSize="small"
                                    onClick={() => {
                                      setFilterColumns((prev) => ({
                                        ...prev,
                                        DueDateFrom: "",
                                        DueDateTo: "",
                                      }));
                                      // setFilteredList(rows);
                                    }}
                                  />
                                ) : (
                                  <SearchIcon fontSize="small" />
                                )}
                              </IconButton>
                            </Paper>
                          </TableCell> */}
                          <TableCell>
                            {/* <Paper
                              sx={{
                                p: "2px 4px",
                                display: "flex",
                                alignItems: "center",
                                width: "100%",
                              }}
                            >
                              <Autocomplete
                                id={""}
                                disableClearable
                                options={["UNPAID", "PAID", "PARTIAL"]}
                                isOptionEqualToValue={(option, value) =>
                                  option == value
                                }
                                clearIcon={
                                  filterColumns.Status !== "" ? (
                                    <ClearIcon style={{ fontSize: "20px" }} />
                                  ) : null
                                }
                                value={filterColumns.Status}
                                // onChange={onChange}
                                onChange={(e, value) =>
                                  handleFilterBySearch(e, "Status", value)
                                }
                                size="small"
                                sx={{ height: "32px" }}
                                renderOption={(props, option) => (
                                  <>
                                    <MenuItem
                                      {...props}
                                      key={option}
                                      value={option}
                                    >
                                      <ListItemText primary={option} />
                                    </MenuItem>
                                  </>
                                )}
                                renderInput={(params) => (
                                  <TextField
                                    sx={{
                                      minWidth: "100px",
                                      border: "none", // Ensure border is removed
                                      "& .MuiInput-underline:before": {
                                        borderBottom: "none", // Remove underline in standard variant
                                      },
                                      "& .MuiInput-underline:hover:not(.Mui-disabled):before":
                                      {
                                        borderBottom: "none", // Remove hover effect
                                      },
                                      "& .MuiInput-underline:after": {
                                        borderBottom: "none", // Remove underline for focused state
                                      },
                                      "& fieldset": { border: "none" },
                                    }}
                                    placeholder={"Search"}
                                    variant="standard"
                                    InputLabelProps={{
                                      shrink: true,
                                      style: { color: "black" },
                                    }}
                                    // onFocus={(e) => {
                                    //   // When the input is focused, change the label to empty
                                    //   e.target.placeholder = ""; // Remove placeholder text on focus if needed
                                    // }}
                                    // onBlur={(e) => {
                                    //   // When the input loses focus, revert changes if necessary
                                    //   e.target.placeholder = filterColumns.Status
                                    //     ? ""
                                    //     : "Search"; // Revert placeholder text on blur if needed
                                    // }}
                                    {...params}
                                  />
                                )}
                              />
                              <IconButton type="button" sx={{ p: "0px" }}>
                                {filterColumns.Status !== "" ? (
                                  <Clear
                                    fontSize="small"
                                    onClick={() => {
                                      setFilterColumns((prev) => ({
                                        ...prev,
                                        Status: "",
                                      }));
                                      // setFilteredList(invoiceRows);
                                    }}
                                  />
                                ) : (
                                  <SearchIcon fontSize="small" />
                                )}
                              </IconButton>
                            </Paper> */}
                          </TableCell>
                          {/* <TableCell>
                      <Paper
                        sx={{
                          p: "2px 4px",
                          display: "flex",
                          alignItems: "center",
                          width: "100%",
                        }}
                      >
                        <InputBase
                          name="BalanceDueAmount"
                          value={filterColumns.BalanceDue}
                          onChange={(e) =>
                            invoiceFilterSearch(e, "BalanceDueAmount")
                          }
                          sx={{ flex: 1 }}
                          placeholder="Search"
                          autoComplete="off"
                        />
                        <IconButton type="button" sx={{ p: "0px" }}>
                          {filterColumns.BalanceDue !== "" ? (
                            <Clear
                              fontSize="small"
                              onClick={() => {
                                setFilterColumns((prev) => ({
                                  ...prev,
                                  BalanceDue: "",
                                }));
                                setFilteredList(invoiceRows);
                              }}
                            />
                          ) : (
                            <SearchIcon fontSize="small" />
                          )}
                        </IconButton>
                      </Paper>
                    </TableCell> */}

                          <TableCell className="actionBackGround" sx={{backgroundColor:"transparent !important"}}></TableCell>
                        </TableRow>
                        {invoiceRows.length > 0 ? (
                          invoiceRows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row, index) => {
                            const isItemSelected = isSelected(row.invoiceid);
                            const labelId = `enhanced-table-checkbox-${index}`;
                            let status = row.statuscd;
                            switch (row.statuscd) {
                              case 'Paid':
                                status = (
                                  <Typography
                                    sx={{
                                      color: row.cancelflag === 1 ? 'gray' : '#009933',
                                      opacity: row.cancelflag === 1 ? 0.5 : 1,
                                      fontSize: '13px',
                                      display: 'flex',
                                      alignItems: 'center',
                                    }}
                                  >
                                    <CheckCircleIcon
                                      sx={{
                                        fontSize: '15px',
                                        marginRight: '5px',
                                      }}
                                    />{' '}
                                    {row.statuscd}
                                  </Typography>
                                );
                                break;
                              case 'Unpaid':
                                status = (
                                  <Typography
                                    sx={{
                                      color: row.cancelflag === 1 ? 'gray' : '#eb4141',
                                      opacity: row.cancelflag === 1 ? 0.5 : 1,
                                      fontSize: '13px',
                                      display: 'flex',
                                      alignItems: 'center',
                                    }}
                                  >
                                    <ErrorIcon
                                      sx={{
                                        fontSize: '15px',
                                        marginRight: '5px',
                                      }}
                                    />{' '}
                                    {row.statuscd}
                                  </Typography>
                                );
                                break;
                              case 'Partial':
                                status = (
                                  <Typography
                                    sx={{
                                      color: row.cancelflag === 1 ? 'gray' : '#6096d9',
                                      opacity: row.cancelflag === 1 ? 0.5 : 1,
                                      fontSize: '13px',
                                      display: 'flex',
                                      alignItems: 'center',
                                    }}
                                  >
                                    <RunningWithErrorsIcon
                                      sx={{
                                        fontSize: '15px',
                                        marginRight: '5px',
                                      }}
                                    />{' '}
                                    {row.statuscd}
                                  </Typography>
                                );
                                break;

                              default:
                                break;
                            }
                            let currencySymbol = '₹'; // billingCurrencyOptions.find((elem) => row.CurrencyCode == elem.value)?.sign
                            let title = row.cancelflag === 1 ? 'Cancelled' : '';
                            let phone = row?.phonenumber || '';

                            return (
                              <TableRow
                                hover
                                className={row.cancelflag === 1 ? 'rowInactiveMuted' : ''}
                                // onClick={(event) => handleClick(event, row.InvoiceID)}
                                role="checkbox"
                                aria-checked={isItemSelected}
                                tabIndex={-1}
                                key={index}
                                selected={isItemSelected}
                                onClick={() => handleRowClick(row)}
                                style={{ cursor: 'pointer' }}
                                sx={{
                                  '.MuiTableCell-root': {
                                    backgroundColor: 'transparent ',
                                    borderBottom: 'none',
                                  },
                                }}
                              >
                                <TableCell
                                  // component="th"
                                  title={title}
                                  id={labelId}
                                  scope="row"
                                  // padding="none"
                                >
                                  {row.invoicedate}
                                </TableCell>
                                {/* <TableCell title={title} align="left">
                                    <MUILink
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        dispatch(
                                          updateViewTitle(
                                            row.cancelflag == 1
                                              ? {
                                                  type: "Cancelled",
                                                  name: row.invoicenumber,
                                                }
                                              : {
                                                  type: "",
                                                  name: row.Invoicenumber,
                                                }
                                          )
                                        );
                                        // dispatch(updateTitle(row.CancelFlag == 1 ? JSON.stringify({ type: "Cancelled", name: row.InvoiceNumber }) :
                                        //   JSON.stringify({ type: "", name: row.InvoiceNumber })));
                                        if (
                                          row.invoicetypecd == "SalesTaxable"
                                        ) {
                                          navigate(
                                            // "/viewinvoiceTaxable",
                                            "/viewnewinvoicetax",
                                            {
                                              state: {
                                                id: row.invoiceid,
                                                view: true,
                                              },
                                            }
                                          );
                                          setBackdropOpen(true);
                                        } else if (
                                          row.invoicetypecd == "PosInvoice"
                                        ) {
                                          navigate("/viewpos", {
                                            state: {
                                              id: row.invoiceid,
                                              view: true,
                                            },
                                          });
                                          setBackdropOpen(true);
                                        }
                                      }}
                                      underline="hover"
                                      sx={{ cursor: "pointer" }}
                                    >
                                      <Typography
                                        sx={{
                                          fontSize: "13px",
                                          display: "flex",
                                          alignItems: "center",
                                        }}
                                      >
                                        {" "}
                                        <Typography>
                                          {" "}
                                          {row.invoicenumber}{" "}
                                        </Typography>
                                      </Typography>
                                    </MUILink>
                                  </TableCell> */}
                                <TableCell title={title} align="left">
                                  <a
                                    className="myLink"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                    }}
                                    href={`/viewpos/${row.invoicenumber}?transaction=${row.invoiceid}`}
                                    target="_blank"
                                    rel="noreferrer"
                                  >
                                    {row.invoicenumber}
                                  </a>
                                </TableCell>

                                {row.invoicetypecd == 'SalesInvoice' ? (
                                  <TableCell
                                    title={title}
                                    align="left"
                                    sx={{
                                      maxWidth: '100px',
                                      whiteSpace: 'nowrap',
                                      overflow: 'hidden',
                                      textOverflow: 'ellipsis',
                                    }}
                                  >
                                    <Tooltip title={row?.partyname} placement="right">
                                      <span
                                        style={{ display: 'block', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}
                                      >
                                        <a
                                          underline="hover"
                                          style={{
                                            color: theme.palette.text.Link,
                                            cursor: 'pointer',
                                          }}
                                          href={`/viewLedger?id=${row?.partyid}&&name=${row?.partydisplayname}&&page=/salesInvoiceReport`}
                                          onClick={(e) => {
                                            e.stopPropagation();
                                            e.preventDefault();
                                            // dispatch(
                                            //   updateViewTitle(
                                            //     row.cancelflag == 1
                                            //       ? {
                                            //         type: "Cancelled",
                                            //         name: row.invoicenumber,
                                            //       }
                                            //       : {
                                            //         type: "",
                                            //         name: row.invoicenumber,
                                            //       }
                                            //   )
                                            // );
                                            dispatch(updateTitle(row.invoicenumber));
                                            if (row?.partyid !== '') {
                                              // localStorage.removeItem('IsLedgerViewModalOpen')
                                              // setBackdropOpen(true);
                                              // setAccountName(row?.PartyDisplayName);
                                              setAccountID(row?.partyid);
                                              // getModalData(row?.PartyID);
                                            }
                                          }}
                                        >
                                          {' '}
                                          {row?.partyname}
                                        </a>
                                      </span>
                                    </Tooltip>
                                  </TableCell>
                                ) : (
                                  <TableCell
                                    title={title}
                                    align="left"
                                    sx={{
                                      maxWidth: '100px',
                                      whiteSpace: 'nowrap',
                                      overflow: 'hidden',
                                      textOverflow: 'ellipsis',
                                    }}
                                  >
                                    <Tooltip title={row?.partyname} placement="right">
                                      <span
                                        style={{ display: 'block', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}
                                      >
                                        {row?.partyname}
                                      </span>
                                    </Tooltip>
                                  </TableCell>
                                )}
                                <TableCell title={title} align="right">
                                  {phone}
                                </TableCell>
                                <TableCell title={title} align="right">
                                  {currencySymbol} {MoneyFormatv3(row.invoiceamount, 'en-IN')}
                                </TableCell>
                                {/* <TableCell title={title} align="left">
                                    {row.duedate}
                                  </TableCell> */}
                                <TableCell title={title} align="left">
                                  {' '}
                                  {row.invoicetypecd !== 'PosInvoice' ? (
                                    status
                                  ) : (
                                    <Typography
                                      sx={{
                                        color: row.cancelflag === 1 ? 'gray' : '#009933',
                                        opacity: row.cancelflag === 1 ? 0.5 : 1,
                                        fontSize: '13px',
                                        display: 'flex',
                                        alignItems: 'center',
                                      }}
                                    >
                                      <CheckCircleIcon
                                        sx={{
                                          fontSize: '15px',
                                          marginRight: '5px',
                                        }}
                                      />{' '}
                                      {'Paid'}
                                    </Typography>
                                  )}
                                </TableCell>
                                {/* <TableCell></TableCell> */}
                                {/* <TableCell align="left">
                                {row.InvoiceTypeCD !== "PosInvoice"
                                  ? MoneyFormatv3(row.BalanceDueAmount)
                                  : "0.00"}
                              </TableCell> */}
                                <TableCell className="actionBackGround" align="center" sx={{position :!showActions ? 'relative' : 'sticky'}}>
                                  <Box
                                     className="actionCellStyle"
                                  >
                                    <Tooltip title={'Download PDF'} placement="left" disableInteractive arrow>
                                      <IconButton
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          e.preventDefault();
                                          checkandopenpdf(row.invoicepdf);
                                        }}
                                        aria-label="delete"
                                        sx={{
                                          margin: '0px 2px',
                                          padding: '5px',
                                          backgroundColor: '#c5d6dc',
                                          border:"solid 1px black"
                                        }}
                                      >
                                        <img src={pdfImage} height={10} alt="Download" />
                                      </IconButton>
                                    </Tooltip>

                                    <Tooltip title={'Print'} placement="left" disableInteractive arrow>
                                      <IconButton
                                        onClick={(e) => {
                                          e.preventDefault();
                                          e.stopPropagation();
                                          fetchAndPrintPDF(row.invoicepdf);
                                          console.log(row, '===>rowwwww');
                                        }}
                                        aria-label="delete"
                                        sx={{
                                          margin: '0px 2px',
                                          padding: '5px',
                                          backgroundColor: '#c5d6dc',
                                          border:"solid 1px black"
                                          // backgroundColor: '#b1d1f97d'
                                        }}
                                      >
                                        <Print
                                          sx={{
                                            fontSize: '10px',
                                            color: '#36454f',
                                            // color: '#6096d9'
                                          }}
                                        />
                                      </IconButton>
                                    </Tooltip>
                                    {/* {row.expiredtimestamp === 0 && row.cancelflag == 0 ? ( */}
                                      <Tooltip title={row.cancelflag == 0 ? 'Edit' : 'cannot Edit'} placement="right" disableInteractive arrow >
                                        <IconButton
                                          onClick={(e) => {
                                            e.stopPropagation();
                                            if (Freeze == 1) {
                                              return handleFreeze();
                                            }
                                            console.log(row, 'rowww');
                                            dispatch(updateTitle(row.invoicenumber));
                                            if (row.invoicetypecd == 'SalesInvoice') {
                                              localStorage.removeItem('SalesIDTaxable');
                                              localStorage.removeItem('SalesTaxViewMode');
                                              navigate('/editinvoiceTaxable', {
                                                state: {
                                                  id: row.invoiceid,
                                                },
                                              });
                                            } else if (row.invoicetypecd == 'PosInvoice') {
                                              localStorage.removeItem('PosID');
                                              localStorage.removeItem('PosViewMode');
                                              navigate('/editpos', {
                                                state: {
                                                  id: row.invoiceid,
                                                },
                                              });
                                            }
                                          }}
                                          aria-label="delete"
                                          sx={{
                                            margin: '0px 2px',
                                            padding: '5px',
                                            backgroundColor: '#D0EFFF',
                                            border:"solid 1px black"
                                          }}
                                        >

                                          {
                                            row.expiredtimestamp === 0 && row.cancelflag == 0 ?<Edit
                                            sx={{
                                              fontSize: '10px',
                                              color: '#42A5F5',
                                            }}
                                          /> : 
                                          <EditOff sx={{ fontSize: "10px", color: '#6096d9', }} />
                                          }
                                          
                                        </IconButton>
                                      </Tooltip>
                                    {/* ) : null} */}
                                    <Tooltip title={'Share'} placement="left" disableInteractive arrow>
                                      <IconButton
                                        onClick={(e) => {
                                          e.preventDefault();
                                          e.stopPropagation();
                                          // For individual Share, use separate state
                                          // that doesn't interfere with bulk selection
                                          setIndividualEmailSelection([
                                            {
                                              PartyID: row?.partyid,
                                              Email: row?.partyemail,
                                              PartyDisplayName: row?.partyname,
                                              invoiceid: row.invoiceid,
                                              invoicenumber: row?.invoicenumber,
                                              invoicetypecd: row?.invoicetypecd,
                                            },
                                          ]);
                                          setShareOpen(row.invoicepdf, true);
                                        }}
                                        aria-label="delete"
                                        sx={{
                                          margin: '0px 2px',
                                          padding: '5px',
                                          backgroundColor: '#E8F5E9',
                                          border:"solid 1px black"
                                          // backgroundColor: '#b1d1f97d'
                                        }}
                                      >
                                        <Share
                                          sx={{
                                            fontSize: '10px',
                                            color: '#388E3C',
                                            // color: '#6096d9'
                                          }}
                                        />
                                      </IconButton>
                                    </Tooltip>
                                    {/* <ThreeDot
                                    onPrint={(e) => {
                                      printInvoice(row);
                                    }}
                                    onView={(e) => {
                                      e.stopPropagation();
                                      dispatch(updateTitle(row.InvoiceNumber));
                                      if (row.InvoiceTypeCD == "SalesInvoice") {
                                        navigate(
                                          // "/viewinvoiceTaxable",
                                          "/viewnewinvoicetax",
                                          {
                                            state: {
                                              id: row.InvoiceID,
                                              view: true,
                                            },
                                          }
                                        );
                                      } else if (
                                        row.InvoiceTypeCD == "PosInvoice"
                                      ) {
                                        navigate("/viewpos", {
                                          state: {
                                            id: row.InvoiceID,
                                            view: true,
                                          },
                                        });
                                      }
                                    }}
                                    onDelete={
                                      row.ExpiredTimeStamp === 0
                                        ? (e) => {
                                          e.stopPropagation();
                                          setDeleteModalStatus(true);
                                          setItemData({
                                            id: row.InvoiceID,
                                            ind: index,
                                            invoicetype:
                                              row.InvoiceTaxableTypeCD,
                                          });
                                        }
                                        : ""
                                    }
                                    onEdit={
                                      row.ExpiredTimeStamp === 0 &&
                                        row.CancelFlag == 0
                                        ? (e) => {
                                          e.stopPropagation();
                                          dispatch(
                                            updateTitle(row.InvoiceNumber)
                                          );
                                          if (
                                            row.InvoiceTypeCD ==
                                            "SalesInvoice"
                                          ) {
                                            localStorage.removeItem(
                                              "SalesIDTaxable"
                                            );
                                            localStorage.removeItem(
                                              "SalesTaxViewMode"
                                            );
                                            navigate("/editinvoiceTaxable", {
                                              state: { id: row.InvoiceID },
                                            });
                                          } else if (
                                            row.InvoiceTypeCD == "PosInvoice"
                                          ) {
                                            localStorage.removeItem("PosID");
                                            localStorage.removeItem(
                                              "PosViewMode"
                                            );
                                            navigate("/editpos", {
                                              state: { id: row.InvoiceID },
                                            });
                                          }
                                        }
                                        : ""
                                    }
                                    onCancel={
                                      row.ExpiredTimeStamp === 0 &&
                                        row.CancelFlag == 0
                                        ? (e) => {
                                          e.stopPropagation();
                                          cancelInvoice(row);
                                          setItemData({
                                            id: row.InvoiceID,
                                            ind: index,
                                            CancelFlag: row.CancelFlag,
                                            invoicetype:
                                              row.InvoiceTaxableTypeCD,
                                          });
                                        }
                                        : ""
                                    }
                                  ></ThreeDot> */}
                                  </Box>
                                </TableCell>
                              </TableRow>
                            );
                          })
                        ) : circularOpen == false && invoiceRows.length <= 0 && !dataCount > 0 ? (
                          <>
                            <TableRow>
                              <TableCell height={400} align="center" colSpan={9} sx={{ border: 'none' }}>
                                No Data Found
                              </TableCell>
                            </TableRow>
                          </>
                        ) : (
                          ''
                        )}
                        {circularOpen == true &&
                          limit > 0 &&
                          Array.from({ length: limit }, (_, index) => (
                            <TableRow key={index}>
                              <TableCell colSpan={12}>
                                <Skeleton variant="text" sx={{ fontSize: '2rem' }} />
                              </TableCell>
                            </TableRow>
                          ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                  {dataCount > 0 && (
                    <TablePagination
                      // rowsPerPageOptions={[5, 10, 25,{ label: 'All', value: -1 }]}
                      rowsPerPageOptions={defaultRowsPerPageOptions}
                      component="div"
                      count={dataCount}
                      rowsPerPage={rowsPerPage}
                      page={page}
                      onPageChange={handleChangePage}
                      onRowsPerPageChange={handleChangeRowsPerPage}
                    />
                  )}
                </Box>
              )}
            </>
          )}

          {/* POS Sales Table */}
        </Box>
      </>
      {shareOpen ? (
        <ShareModal
          open={shareOpen}
          emailData={{
            selectedRow: individualEmailSelection?.map((inv) => ({
              id: Number(inv.invoiceid),
              recipientId: Number(inv.PartyID),
              email: inv.Email,
              name: inv.PartyDisplayName,
              invoiceNumber: inv.invoicenumber,
              invoiceType: inv.invoicetypecd || 'PosInvoice',
            })),
            type: 'PosInvoice',
          }}
          setOpen={setShareOpen}
        />
      ) : null}
      <CancelInvoice
        open={cancelModalStatus}
        setOpen={setCancelModalStatus}
        itemData={itemData}
        rows={invoiceRows}
        setRows={setInvoiceROws}
        listInvoices={listInvoices}
        // listPos={listPos}
      />
      <DeleteInvoice
        open={deleteModalStatus}
        setOpen={setDeleteModalStatus}
        itemData={itemData}
        rows={invoiceRows}
        setRows={setInvoiceROws}
        listInvoices={listInvoices}
        // listPos={listPos}
      />

      <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={backdropOpen}>
        <CircularProgress color="inherit" />
      </Backdrop>
      {/* <ExportData
        setOpen={setExportModalOpen}
        open={exportModalOpen}
        item={exportItem}
      /> */}
      <DeletedSelectedInvoice
        open={deleteSelectedModal}
        setOpen={setDeleteSelectedModal}
        // rows={filteredList}
        // setRows={setFilteredList}
        itemsData={selected}
        listInvoices={listInvoices}
      />
      {WarningModal}
      {accountID && <LedgerTransactionModalv2 open={accountID} accountId={accountID} onClose={() => setAccountID('')} />}
      <SendEmailModalWrapper {...modalProps} />
    </Box>
  );
}

export default AllPos;
